import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import AuthWrapper from "./components/Auth/AuthWrapper";
import Submit from "./routes/Submit";
import TaskDetail from "./routes/TaskDetail";
import Tasks from "./routes/Tasks";

const App: React.FC = () => {
  return (
    <Router>
      <AuthWrapper>
        <Routes>
          <Route path="/" element={<Navigate to="/submit" replace />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/tasks/:id" element={<TaskDetail />} />
          <Route path="*" element={<Navigate to="/submit" replace />} />
        </Routes>
      </AuthWrapper>
    </Router>
  );
};

export default App;
